var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 30,
    height: 30,
    rx: 12,
    fill: "#1A1F37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6629 12.9675C21.6193 12.9258 21.5612 12.9025 21.5009 12.9025C21.4405 12.9025 21.3825 12.9258 21.3389 12.9675L15.9453 18.1199C15.9224 18.1419 15.9042 18.1682 15.8918 18.1973C15.8793 18.2265 15.8729 18.2579 15.873 18.2896L15.8721 23.1253C15.8721 23.374 15.9709 23.6124 16.1467 23.7882C16.3225 23.964 16.5609 24.0628 16.8096 24.0628H19.625C19.7493 24.0628 19.8686 24.0134 19.9565 23.9255C20.0444 23.8376 20.0938 23.7184 20.0938 23.5941V19.6097C20.0938 19.5475 20.1185 19.4879 20.1624 19.444C20.2064 19.4 20.266 19.3753 20.3281 19.3753H22.6719C22.734 19.3753 22.7937 19.4 22.8376 19.444C22.8816 19.4879 22.9063 19.5475 22.9063 19.6097V23.5941C22.9063 23.7184 22.9556 23.8376 23.0436 23.9255C23.1315 24.0134 23.2507 24.0628 23.375 24.0628H26.1893C26.4379 24.0628 26.6764 23.964 26.8522 23.7882C27.028 23.6124 27.1268 23.374 27.1268 23.1253V18.2896C27.1268 18.2579 27.1204 18.2265 27.108 18.1973C27.0955 18.1682 27.0773 18.1419 27.0544 18.1199L21.6629 12.9675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3825 17.1537L26.1911 15.0572V11.8759C26.1911 11.7515 26.1417 11.6323 26.0538 11.5444C25.9659 11.4565 25.8466 11.4071 25.7223 11.4071H24.3161C24.1918 11.4071 24.0725 11.4565 23.9846 11.5444C23.8967 11.6323 23.8473 11.7515 23.8473 11.8759V12.8134L22.1505 11.1909C21.9917 11.0304 21.7555 10.9384 21.5004 10.9384C21.2461 10.9384 21.0105 11.0304 20.8517 11.1912L14.6203 17.1531C14.4381 17.3289 14.4152 17.6181 14.581 17.8085C14.6227 17.8566 14.6736 17.8956 14.7309 17.9234C14.7881 17.9511 14.8504 17.9669 14.9139 17.9698C14.9774 17.9727 15.0409 17.9627 15.1004 17.9403C15.1599 17.9179 15.2143 17.8836 15.2601 17.8395L21.3392 12.0306C21.3828 11.9888 21.4409 11.9655 21.5012 11.9655C21.5616 11.9655 21.6196 11.9888 21.6632 12.0306L27.7429 17.8395C27.8325 17.9254 27.9524 17.9723 28.0765 17.9699C28.2006 17.9675 28.3186 17.916 28.4047 17.8266C28.5846 17.6403 28.5697 17.3327 28.3825 17.1537Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_12",
    x: 0.5,
    y: -2.38419e-7,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_12",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/homeImage.a8068999e49dd72c33958d1f7a61ecba.svg";
export { ForwardRef as ReactComponent };